// extracted by mini-css-extract-plugin
export default {"emptyDiv":"emptyDiv__F9xF3"};